import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext({
  isDark: false,
  toggleTheme: () => {}
});

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    // iOS Safari Private Browsing throws on localStorage access; default to
    // light theme there rather than crashing the whole app.
    try {
      const saved = localStorage.getItem('isp_theme');
      return saved === 'dark';
    } catch (_) {
      return false;
    }
  });

  useEffect(() => {
    const root = document.documentElement;
    if (isDark) {
      root.setAttribute('data-theme', 'dark');
      try { localStorage.setItem('isp_theme', 'dark'); } catch (_) {}
    } else {
      root.removeAttribute('data-theme');
      try { localStorage.setItem('isp_theme', 'light'); } catch (_) {}
    }
  }, [isDark]);

  const toggleTheme = () => setIsDark(prev => !prev);

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
